class s{static push(t,p){p&&s._types.length>0?console.assert("Script Ordering Error. Contact support@playcanvas.com"):s._types.push(t)}}s._types=[];export{s as ScriptTypes};
